import { list, remove } from 'app/api/costImpression';
import UserContext from 'app/context/UserContext';
import useRequest from 'app/hooks/useRequest';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useTable } from 'react-table';
import PageHeader from 'app/components/header/PageHeader';
import { Button, ButtonGroup, Card, Col } from 'react-bootstrap';
import CostImpressionFooter from './CostImpressionFooter';
import ModalUpload from './ModalUpload';
import CostImpressionDropdown from './CostImpressionDropdown';
import { toast } from 'react-toastify';

function CostImpressionTable() {
  const { response, sendData } = useRequest();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const { user } = useContext(UserContext);
  const [taskToEdit, setTaskToEdit] = useState(null);
  const { response: deleteRes, sendData: sendDelete } = useRequest();

  const [showModalUpload, setShowModalUpload] = useState(false);

  const [isFetched, setIsFetched] = useState(false);

  function deleteTask(id) {
    const config = remove(user.token, id);
    sendDelete(config);
  }

  useEffect(() => {
    sendResponse();
  }, [page, limit]);

  useEffect(() => {
    if (deleteRes?.data) {
      toast.success(deleteRes.data.message, { theme: 'colored' });
      sendResponse();
    }
  }, [deleteRes]);

  useEffect(() => {
    sendResponse();
  }, []);

  function sendResponse() {
    const config = list(user.token, page, limit);
    sendData(config);
  }

  function handlerShowModalUpload() {
    setShowModalUpload(prev => !prev);
    setTaskToEdit(null);
  }

  useEffect(() => {
    if (response?.data) {
      setData(response.data.data);
      setIsFetched(true);
    }
  }, [response]);

  const columns = useMemo(
    () => [
      { Header: 'Cost', accessor: 'noOfCost' },
      { Header: 'Impressions', accessor: 'impressions' },
      {
        Header: 'Action',
        id: 'action',
        Cell: ({ row }) => (
          <CostImpressionDropdown
            row={row}
            onEdit={rowData => {
              setTaskToEdit(row.original);
              setShowModalUpload(true);
            }}
            onDelete={rowData => deleteTask(row.original.id)}
          />
        )
      }
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });
  return (
    <>
      <PageHeader
        col={{ xs: 6 }}
        title="Pricing Impression"
        description=""
        className="mb-3"
      >
        <Col className="d-flex justify-content-end">
          <Button variant="primary" onClick={handlerShowModalUpload} size="sm">
            Add
          </Button>
        </Col>
      </PageHeader>

     {isFetched ? <Card className="mb-3">
        <Card.Body>
          <table
            {...getTableProps()}
            className="table table-striped fs--1 mb-0 overflow-scroll"
          >
            <thead>
              {headerGroups.map(headerGroup => (
                <tr
                  {...headerGroup.getHeaderGroupProps()}
                  key={headerGroup.id}
                  className="bg-200 text-900 text-nowrap align-middle"
                >
                  {headerGroup.headers.map(column => (
                    <th
                      {...column.getHeaderProps()}
                      key={column.id}
                      className="text-nowrap align-middle"
                    >
                      {column.render('Header')}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map(row => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    key={row.id}
                    className="align-middle white-space-nowrap"
                  >
                    {row.cells.map(cell => (
                      <td
                        {...cell.getCellProps()}
                        key={cell.column.id}
                        className="align-middle"
                      >
                        {cell.render('Cell')}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div className="mt-3">
            <CostImpressionFooter
              page={data}
              pageIndex={page - 1}
              pageSize={limit}
              rowCount={response?.data?.pagination?.total || 0}
              setPageSize={value => {
                setLimit(Number(value));
                setPage(1);
              }}
              canPreviousPage={page > 1}
              canNextPage={
                page * limit < (response?.data?.pagination?.total || 0)
              }
              previousPage={() => setPage(prev => Math.max(prev - 1, 1))}
              nextPage={() => setPage(prev => prev + 1)}
              rowsPerPageOptions={[10, 20, 30]}
              table
              rowInfo
              navButtons
              rowsPerPageSelection
            />
          </div>
        </Card.Body>
      </Card>:<Card>
                <Card.Body className="fs--1 fs-lg-0">No records found.</Card.Body>
              </Card>}

      <ModalUpload
        showModal={showModalUpload}
        handlerShowModal={handlerShowModalUpload}
        updateTable={sendResponse}
        taskToEdit={taskToEdit}
      />
    </>
  );
}

export default CostImpressionTable;
